<template>
  <div>
    <div class="page-title">
      <h3>{{'ProfileTitle' | localize }}</h3>
    </div>

    <form class="form" @submit.prevent="submitHandler">
      <div class="input-field">
        <input v-model="name"
            id="description"
            type="text"
            :class="{invalid: $v.name.$dirty || !$v.name.required}"
        >
        <label for="description" >{{'Name' | localize }}</label>
        <small 
          class="helper-text invalid"
          v-if="$v.name.$dirty || !$v.name.required"
        >{{'MessageEN' | localize }}</small>
        
      </div>

  <div class="switch">
    <label>
      English
      <input type="checkbox" v-model="isRulocale">
      <span class="lever"></span>
      Русский
    </label>
  </div>
      <button class="btn waves-effect waves-light" type="submit">
        {{'Update' | localize }}
        <i class="material-icons right">send</i>
      </button>
    </form>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import {required} from 'vuelidate/lib/validators'

export default {
  metaInfo() {
    return {
      title: this.$title('ProfileTitle')
    } 
  },
  data: () => ({
    name: '',
    isRulocale: true
  }),
  validations: {
    name: {required}
  },
  mounted() {
    this.name = this.info.name
    this.isRulocale = this.info.locale === 'ru-Ru'
    setTimeout(() => {
      window.M.updateTextFields()
      },0)
  },
  methods: {
    ...mapActions(['updateInfo']),
    async submitHandler() {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      }
      try {
        await this.updateInfo({
          name: this.name,
          locale: this.isRulocale ? 'ru-Ru' : 'en-US'
        })
      } catch (e) {
        throw e
      }
    }
  },     
  computed: {
    ...mapGetters(['info'])
  }

}
</script>
<style scoped>
  .switch {margin-bottom: 2rem;}
</style>